import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';
import { clearPasskeyFlag } from '../lib/passkeyFlag.js';

export function usePasskeyDevices() {
  return useQuery({
    queryKey: ['passkeys'],
    queryFn: () => api.get('/auth/passkeys'),
    retry: false,
  });
}

export function useDeletePasskey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.delete(`/auth/passkeys/${id}`),
    onSuccess: (_data, id) => {
      const current = queryClient.getQueryData(['passkeys']);
      const remaining = (current?.items ?? []).filter((p) => p.id !== id);
      if (current && remaining.length === 0) clearPasskeyFlag();
      queryClient.invalidateQueries({ queryKey: ['passkeys'] });
    },
  });
}
